import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { graphql } from 'gql/gql';
import { ProjectPickerProjectsQuery, useProjectPickerProjectsQuery } from 'gql/index';

type Props = {
  value: number | null;
  onChange: (projectId: number | null) => void;
  filter?: (project: ProjectPickerProjectsQuery['projects'][number]) => boolean | undefined | null;
};

 graphql(`
  query projectPickerProjects {
    projects {
      id
      name
      isTemplate
      isArchived
      myPermissions {
        tasksPermission
      }
    }
  }
`);

export const ProjectAutocomplete: React.FC<Props> = ({ value, onChange, filter }) => {
  const { formatMessage } = useIntl();
  const { data, isFetching } = useProjectPickerProjectsQuery();

  const projects = useMemo(
    () => (data?.projects ?? []).filter(project => (filter ? filter(project) : true)),
    [data?.projects, filter]
  );

  const selectedProject = projects.find(p => p.id === value) ?? null;
 
  return (
    <Autocomplete
      options={projects}
      loading={isFetching}
      getOptionLabel={option => option.name}
      value={selectedProject}
      onChange={(_, project) => onChange(project?.id ?? null)}
      renderInput={params => (
        <TextField
          {...params}
          label={formatMessage({ id: 'Project' })}
          slotProps={{
            input: {
              ...params.InputProps,
              endAdornment: (
                <>
                  {isFetching ? <CircularProgress color='inherit' size={16} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }
          }}
        />
      )}
    />
  );
};

